import React from "react";
const ArrayLabel = props => {
  const {data, name} = props;
  const listKey = Object.keys(data || {});
  const listValidKey = listKey.filter(key => data[key]);
  return (
    <>
      {!Array.isArray(data) &&
        listValidKey.map((e1, index) => {
          return (
            <>
              {data[e1] && (
                <span>
                  {e1} {`${index != listValidKey.length - 1 ? "- " : ""}`}
                </span>
              )}
            </>
          );
        })}
      {Array.isArray(data) && (
        <>
          {data.map((e, index) => {
            return (
              <span>
                {e} {index < data.length - 1 && data.length > 1 ? "-" : ""}{" "}
              </span>
            );
          })}
        </>
      )}
    </>
  );
};
export default ArrayLabel;
